import type { Jurisdiction } from "../constants/jurisdictions.ts";

export interface GeocoderAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

const PROVINCE_ALIASES: Record<string, number> = {
  caba: 5,
  "capital federal": 5,
  "ciudad autónoma de buenos aires": 5,
  "ciudad autonoma de buenos aires": 5,
  "provincia de buenos aires": 1,
  "buenos aires province": 1,
  "tierra del fuego": 23,
};

export function mapGoogleProvinceToJurisdiction(
  addressComponents: GeocoderAddressComponent[] | undefined,
  jurisdictions: Jurisdiction[]
): number | null {
  if (!addressComponents?.length) return null;

  const provinceComponent = addressComponents.find((ac) =>
    ac.types.includes("administrative_area_level_1")
  );
  if (!provinceComponent) return null;

  const normalized = provinceComponent.long_name.trim().toLowerCase();
  const aliasId = PROVINCE_ALIASES[normalized];
  if (aliasId) return aliasId;

  const match = jurisdictions.find((j) => {
    const jNorm = j.name.toLowerCase();
    return jNorm === normalized || jNorm.includes(normalized) || normalized.includes(jNorm);
  });
  return match?.id ?? null;
}
